import { SmallCheckbox } from 'Presentation/Components/Checkbox'

import { useContext } from 'react'
import { SaleOrderImportViewContext } from './Context'
import { ProjectListViewContext } from '../List/Context'
import { toast } from 'react-toastify'
import formatNumberCommas from 'Utils/formatNumberCommas'

const MOCK_DATA: any[] = [
  {
    saleOrderNo: 'SO-0001',
    productCode: 'P-0001',
    quantity: 10,
  },
  {
    saleOrderNo: 'SO-0002',
    productCode: 'P-0002',
    quantity: 20,
  },
  {
    saleOrderNo: 'SO-0003',
    productCode: 'P-0003',
    quantity: 30,
  },
  {
    saleOrderNo: 'SO-0004',
    productCode: 'P-0004',
    quantity: 40,
  },
  {
    saleOrderNo: 'SO-0005',
    productCode: 'P-0005',
    quantity: 50,
  },
  {
    saleOrderNo: 'SO-0006',
    productCode: 'P-0006',
    quantity: 60,
  },
  {
    saleOrderNo: 'SO-0007',
    productCode: 'P-0007',
    quantity: 70,
  },
  {
    saleOrderNo: 'SO-0008',
    productCode: 'P-0008',
    quantity: 80,
  },
  {
    saleOrderNo: 'SO-0009',
    productCode: 'P-0009',
    quantity: 90,
  },
  {
    saleOrderNo: 'SO-0010',
    productCode: 'P-0010',
    quantity: 100,
  },
]

const ViewModel = () => {
  const { isUpload, updateUpload, updateUploadError, files, updateFiles, data, updateData } =
    useContext(SaleOrderImportViewContext)
  const { isOpenImportProjectModal, toggleImportProjectModal } = useContext(ProjectListViewContext)

  const resetState = () => {
    updateUpload(false)
    updateUploadError(undefined)
    updateFiles([])
  }

  const handleClose = () => {
    toggleImportProjectModal(false)
    resetState()
  }

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files

    if (newFiles) {
      const file = newFiles[0]

      const isFileAlreadyExist = files.some(f => f.name === file.name)
      if (!isFileAlreadyExist) {
        updateFiles([...files, file])
      }
    }
  }

  const handleUploadSeveralFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files

    const checkedFiles: File[] = []

    if (newFiles) {
      const filesArray = Array.from(newFiles)

      filesArray.forEach(f => {
        const isFileAlreadyExist = files.some(file => file.name === f.name)
        if (!isFileAlreadyExist) {
          checkedFiles.push(f)
        }
      })

      updateFiles([...files, ...checkedFiles])
    }
  }

  const removeFile = (index: number) => {
    const newFiles = files.filter((_, i) => i !== index)
    updateFiles(newFiles)
  }

  const handleImport = async () => {
    try {
      if (files.length === 0) {
        toast.error('Please select file to import')
        return
      }

      updateUpload(true)
      updateData(MOCK_DATA)
    } catch (err: any) {
      updateUploadError(err.message)
    }
  }

  const modalsRoot = document.getElementById('root-modals') || document.body

  const TABLE_CONFIGS: any[] = [
    {
      Header: 'No.',
      accessor: 'no',
      width: 50,
      minWidth: 50,
      Cell: ({ row }: any) => row.index + 1,
      disableSortBy: true,
    },
    {
      Header: 'Sale Order No.',
      accessor: 'saleOrderNo',
      width: 150,
      minWidth: 150,
      disableSortBy: true,
    },
    {
      Header: () => <div className='text-end'>Quantity</div>,
      accessor: 'quantity',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <div className='text-end'>{formatNumberCommas(row.original.quantity)}</div>
      ),
    },
    {
      Header: 'Product Code',
      accessor: 'productCode',
      width: 150,
      minWidth: 150,
      disableSortBy: true,
    },
    {
      Header: 'Action',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: () => <SmallCheckbox />,
      disableSortBy: true,
    },
  ]

  return {
    modalsRoot,
    isOpenImportProjectModal,
    isUpload,
    // Before Upload
    files,
    handleClose,
    handleUpload,
    handleUploadSeveralFiles,
    removeFile,
    handleImport,
    // After Upload
    TABLE_CONFIGS,
    data,
  }
}

export default ViewModel
